module.exports = "<div *ngIf=\"errorMessage !== null\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/control-messages/control-messages.component.html
// module id = ./src/app/commons/control-messages/control-messages.component.html
// module chunks = main